// Shared contract for the `ask_clarifying_questions` client-side agent tool.
//
// The schema is defined by the chat server (crm-chat-api) so the model knows
// the tool, but the questions are ANSWERED in the CRM browser (no server
// execute). This module is the single source of truth for the input/output
// shape so the server tool definition, the server-side answer persistence and
// the CRM card can't drift. Each side keeps its own runtime validator (zod)
// and constrains it to these types.

export const ASK_CLARIFYING_QUESTIONS_TOOL = 'ask_clarifying_questions';

export const CLARIFY_LIMITS = {
  maxQuestions: 4,
  maxIdLength: 100,
  minOptions: 2,
  maxOptions: 6,
  maxPromptLength: 200,
  maxOptionLength: 80,
  maxAnswerLength: 500,
} as const;

export type ClarifyingQuestion = {
  id: string;
  prompt: string;
  type: 'choice' | 'text';
  /** Required for `choice` questions. Never includes an "Other" entry. */
  options?: string[];
  allowMultiple?: boolean;
  /** Appends a free-text "Other" row to a `choice` question. Defaults to true. */
  allowOther?: boolean;
  /** Exact label of the recommended option. Single choice only. */
  recommendedOption?: string;
};

export type AskClarifyingQuestionsInput = {
  questions: ClarifyingQuestion[];
};

export type ClarifyAnswer = {
  id: string;
  prompt: string;
  response: string | string[];
};

export type AskClarifyingQuestionsOutput =
  | { success: true; answers: ClarifyAnswer[] }
  | { success: true; skipped: true }
  // Synthesised by the server, never sent by a client: the user typed in the
  // chat box instead of answering, so their next message is the answer.
  | { success: true; skipped: true; notAnswered: true; reason: string }
  | { success: false; error: string };
